export const MisakoHeader = () => {
  return (
    <div className="sticky top-0 z-20 flex w-full justify-between bg-white p-4 md:px-10 md:py-6">
      <div className="mr-auto">
        <img
          width={285}
          height={70}
          src="https://static.byrever.com/ecommerces/misako-shopifytest/logo_1725447639.svg"
          alt="Misako"
          className="h-[1.2rem] w-auto object-contain lg:h-6"
        />
      </div>
      <nav className="flex items-center gap-5 pr-2">
        <a
          href="https://www.misako.com/pages/wishlist"
          target="_blank"
          rel="noreferrer"
          aria-label="Wishlist"
        >
          <img
            src="https://www.misako.com/cdn/shop/files/favorite.svg?v=1731587455"
            width={20}
            height={20}
            alt=""
          />
        </a>
        <a
          href="https://www.misako.com/account"
          target="_blank"
          rel="noreferrer"
          aria-label="Cuenta"
        >
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M19 20V17.7778C19 15.3222 16.9863 13.3333 14.5 13.3333H5.5C3.01375 13.3333 1 15.3222 1 17.7778V20"
              stroke="rgb(21, 21, 21)"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M10 9C12.2091 9 14 7.20914 14 5C14 2.79086 12.2091 1 10 1C7.79086 1 6 2.79086 6 5C6 7.20914 7.79086 9 10 9Z"
              stroke="rgb(21, 21, 21)"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </a>
        <a
          href="https://www.misako.com/collections/top-ventas"
          target="_blank"
          rel="noreferrer"
          aria-label="Top ventas"
        >
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M13.6969 13.9469L18 18.25M15.875 8.6875C15.875 12.7951 12.5451 16.125 8.4375 16.125C4.32988 16.125 1 12.7951 1 8.6875C1 4.57988 4.32988 1.25 8.4375 1.25C12.5451 1.25 15.875 4.57988 15.875 8.6875Z"
              stroke="rgb(21, 21, 21)"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
        </a>
      </nav>
    </div>
  )
}
